import { motion } from "framer-motion";
import { fadeUp } from "../lib/motion";

export default function Reveal({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      transition={{ delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
